import {
    Switch,
    Route,
  } from "react-router-dom";
import BasePage from "../BasePage";
import AddGroupe from "../blog/components/AddGroupe";
import AddFormulaireDeclaration from "../blog/components/addgroupe/AddFormulaireDeclaration";
import AnnonceAdd from "../components/admin/annonce/AnnonceAdd";
import Home from "../Home";
import AddUserToInstution from "../Pages/AddUserToInstution";
import Admin from "../Pages/Admin";
import AjoutConenue from "../Pages/Admin/AjoutConenue";
import ArticleAdd from "../Pages/Admin/articles/ArticleAdd";
import Article from "../Pages/Admin/articles/Articles";
import Cotisation from "../Pages/Admin/contisation/Cotisation";
import DetailDeclaration from "../Pages/Admin/DetailDeclaration";
import Institution from "../Pages/Admin/institution/Institution";
import InstitutionAdd from "../Pages/Admin/institution/InstitutionAdd";
import RicievedDeclaration from "../Pages/Admin/message/RicievedDeclaration";
import Slides from "../Pages/Admin/Slides/Slides";
import Users from "../Pages/Admin/Users";
import UserAdd from "../Pages/Admin/users/UserAdd";
import Annonce from "../Pages/Annonce";
import AnnonceCommunique from "../Pages/AnnonceCommunique";
import AnnonceCommuniqueDetail from "../Pages/AnnonceCommuniqueDetail";
import ArticleSearch from "../Pages/ArticleSearch";
import ConsultationCotisation from "../Pages/ConsultationCotisation";
import ConsultationCotisationDetataches from "../Pages/ConsultationCotisationDetataches";
import DeclarationFormulaire from "../Pages/DeclarationFormulaire";
import DetailBlog from "../Pages/DetailBlog";
import EditInstution from "../Pages/EditInstution";
import Information from "../Pages/Information";
import MessageSent from "../Pages/MessageSent";
import OnlineService from "../Pages/OnlineService";
import RecievedMessageDetail from "../Pages/RecievedMessageDetail";
import RicievedMessage from "../Pages/RicievedMessage";
import TestComponent from "../Pages/TestComponent";
import UserEdit from "../Pages/UserEdit";
import WebAdmin from "../Pages/WebAdmin";
import ProtectedRoute from "../utility/ProtectedRouter";
import DetailNewsScreen from "../advanced/pages/DetailNewsScreen.jsx";
import AdminContentScreen from "../advanced/pages/AdminContentScreen.jsx";
import InformationList from "../advanced/pages/InformationList.jsx";
import InformationDetail from "../advanced/pages/InformationDetail.jsx";
import AnnonceList from "../advanced/pages/ContentAnnonces.jsx";
import AnnonceDetail from "../advanced/pages/ContentAnnonceDetail.jsx";
import DocumentsList from "../advanced/pages/DocumentsList.jsx";
import ContactPage from "../advanced/pages/ContactScreen.jsx";
import LoginScreen from "../advanced/pages/LoginScreen.jsx";
import PageFormulaireDeclaration from "../advanced/pages/FormulaireDeclaration.jsx";
import EditArticle from "../components/admin/articles/EditArticle.jsx";
import AppPhotoGallery from "../advanced/pages/AppPhotoGallery.jsx";
import BriefsEvenements from "../advanced/pages/BriefsEvenements.jsx";
import BriefsDetail from "../advanced/pages/sections/BriefsDetail.jsx";
import EventDetail from "../advanced/pages/sections/EventDetail.jsx";

import ForgotPassword from "../advanced/pages/ForgotPasswordScreen.jsx";
import ResetPassword from "../advanced/pages/ResetPasswordScreen.jsx";

const RouteComponent = () => {
    return ( 
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/detail_new/:id" component={DetailNewsScreen} />
          <Route exact path="/admin-content/:headerId/:contentId" component={AdminContentScreen} />
          <Route exact path="/informations" component={InformationList} />
          <Route exact path="/information/:id" component={InformationDetail} />
          <Route exact path="/declaration-accident" component={PageFormulaireDeclaration} />
          <Route exact path="/admin-content/:headerId/:contentId" component={AdminContentScreen} />
          <Route exact path="/annonce-communique" component={AnnonceList} />
          <Route exact path="/annonce/:id" component={AnnonceDetail} />
          <Route exact path="/online-service" component={DocumentsList} />
          <Route exact path="/contacts" component={ContactPage} />
          <Route exact path="/se-connecter" component={LoginScreen} />
          <Route exact path="/breves" component={BriefsDetail} />
          <Route exact path="/evenements" component={EventDetail} />

          <Route exact path="/galerie-photos" component={AppPhotoGallery} />
          <Route exact path="/calendrDIRECTEURier-evenements" component={BriefsEvenements} />

          <Route exact path="/informations" component={Information} />
          <Route exact path="/detail/:id" component={DetailBlog} />
          <Route exact path="/institution_edit/:id" component={EditInstution} />
          <Route exact path="/article-search/:id" component={ArticleSearch} />
          <Route exact path="/admin-article-edit/:id" component={EditArticle} />
          <Route exact path="/login" component={LoginScreen} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/reset-password" component={ResetPassword} />
          <Route exact path="/detail" component={BasePage} />
          {/* <Route exact path="/annonce-communique" component={AnnonceS} />
          <Route exact path="/annonce-communique/:id" component={AnnonceCommuniqueDetail} /> */}
          <Route exact path="/online-service" component={OnlineService} />
           <ProtectedRoute exact path="/client-consultation-cotisation-afilier" redirectTo="/se-connecter" component={ConsultationCotisation} forceLogout={true} />
          <ProtectedRoute exact path="/client-consultation-cotisation-detaches" redirectTo="/se-connecter" component={ConsultationCotisationDetataches} forceLogout={true} />
          <Route exact path="/client-declaration" component={DeclarationFormulaire} />
          <ProtectedRoute exact path="/admin" component={Admin} /> 
          <ProtectedRoute exact path="/users" component={Users} /> 
          <ProtectedRoute exact path="/admin-article" component={Article} /> 
          <ProtectedRoute exact path="/admin-article-add" component={ArticleAdd} /> 
          <ProtectedRoute name="add_user" exact path="/admin-add-user" component={UserAdd} /> 
          <ProtectedRoute name="admin-slides" exact path="/admin-slides" component={Slides} /> 
          <ProtectedRoute  exact path="/test-compontent" component={TestComponent} /> 
          <ProtectedRoute  exact path="/institution" component={Institution} /> 
          <ProtectedRoute  exact path="/cotisations" component={Cotisation} /> 
          <ProtectedRoute  exact path="/message-sent" component={MessageSent} />  
          <ProtectedRoute  exact path="/institutions/add" component={InstitutionAdd} /> 
          <ProtectedRoute  exact path="/web" component={WebAdmin} /> 
          <ProtectedRoute  exact path="/add-groupe" component={AddGroupe} /> 
          <ProtectedRoute  exact path="/ricieved-message" component={RicievedMessage} /> 
          <ProtectedRoute  exact path="/ricieved-declaration" component={RicievedDeclaration} /> 
          <ProtectedRoute  exact path="/ricieved-message/:id" component={RecievedMessageDetail} /> 
          <ProtectedRoute  exact path="/add-user-to-institution/:id" component={AddUserToInstution} /> 
          <ProtectedRoute  exact path="/show-detail-declaration/:id" component={DetailDeclaration} /> 
          <ProtectedRoute  exact path="/edit-user/:id" component={UserEdit} /> 
          <ProtectedRoute  exact path="/ajouter-contenu/:id" component={AjoutConenue} /> 
          <ProtectedRoute  exact path="/add-formulaire" component={AddFormulaireDeclaration} /> 
          <ProtectedRoute  exact path="/annonce" component={Annonce} /> 
          <ProtectedRoute  exact path="/annonce-add" component={AnnonceAdd} /> 
        </Switch>
     );
}
 
export default RouteComponent;